import React, { useState, useContext, useEffect, useRef } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import Box from '@mui/material/Box';
import { BiSolidDownArrow } from "react-icons/bi";
import ButtonTextCustom from '../elements/ButtonTextCustom';
import InputCustom from '../elements/InputCustom';
import InputSelectCustom from '../elements/InputSelectCustom';
import UploaderFileContainer from '../elements/UploaderFile/UploaderFileContainer';

import TextareaCustom from '../elements/TextareaCustom';

import UploadMediaMultiLang from '../elements/UploadMediaMultiLang';

import { ConfigurationContext } from '../../context';

import { dataObjectEvaluationCertificate,
         getNameLanguage,
         dataObjectMultipleChoiceWithImage,
         dataObjectOpenAnswer,
         getTypeAssesment, } from '../../helpers/functions';

import { EditIcon,
         LanguageIcon,
         DragIndicatorIcon,
         HeadlineIcon } from '../../helpers/icons';

import { useTranslation } from 'react-i18next';
import { set } from 'ramda';

const WrapperStyled = styled.div`
    display: flex;
    width: 800px;
    justify-content: flex-start;
    flex-direction: column;
    >.title{
        font-size: 24px;
        line-height: 24px;
        font-weight: 700;
        padding: 20px 20px;
    }
    .form_certificate{
        .field{
            margin-bottom: 10px;
        }
        .uploader_file{
            margin-bottom: 10px;
        }
    }
    .question_type_container.show{
        display: flex;
        flex-direction: column;
    }
    .question_type_container.hide{
        display: none;
    }
    
    

    .box_lang{

        .question_type_container{
            padding: 35px 50px;
            box-sizing: border-box;
            background-color: ${props => `rgb(${props.pancolors.light_white})`};
            margin-top: 0;
            border-radius: 8px;
            .title{
                display: flex;
                flex-direction: row;
                align-items: center;
                .icon{
                    display: flex;
                    svg{
                        fill: ${props => `rgb(${props.pancolors.black_overwhite})`};  
                    }
                }
                .text{
                    color: ${props => `rgb(${props.pancolors.black_overwhite})`};
                    font-size: 18px;
                    line-height: 18px;
                    font-weight: 600;
                    margin-left: 7px;
                }
            }
        }

        .bt_show_more_info{
            .icon{
                svg{
                    width: 13px;
                    height: 13px;
                }
            }
            .text{
                font-size: 14px!important;
                margin-left: 0;
            }
        }

        &.error{
            border: 1px solid ${props => `rgb(${props.pancolors.red})`}!important;
            .head_form_lang{
                
                >.title{
                    .icon{
                        svg{
                            fill: ${props => `rgb(${props.pancolors.red})`}!important;
                        }
                    }
                    .text{
                        color: ${props => `rgb(${props.pancolors.red})`}!important;
                    }
                }
            }
        }
        &.multilang{
            box-sizing: border-box;
            padding: 0px 30px 0px;
            background-color: ${props => `rgb(${props.pancolors.light_white})`};
            border: 1px solid ${props => `rgb(${props.pancolors.light_white})`};
            margin-bottom: 20px;
            .question_type_container{
                padding: 5px 50px;
            }
            &.open{
                padding: 0px 30px 20px;
            }
            .head_form_lang{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                box-sizing: border-box;
                padding: 10px 0px;
                
                >.title{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    .icon{
                        svg{
                            width: 26px;
                            height: 26px;
                        }
                    }
                    .text{
                        font-size: 18px;
                        line-height: 18px;
                        font-weight: 700;
                        color: ${props => `rgb(${props.pancolors.dots})`};
                        margin-left: 10px;
                    }
                }
            }
        }
    }
`

const Certificate = (props) => {

    const { t } = useTranslation();

    const { panColors, 
            userCountrySelected } = useContext(ConfigurationContext);
    const [ showLanguage, setShowLanguage ] = useState(null);
    const [ langHaveError, setLangHaveError ] = useState([]);
    const [ percent, setPercent ] = useState(null);

    const { scope, 
            contentByLang, 
            setContentByLang,
            certificateLoaded,
            setCertificateLoaded } = props;
    
    let abortControllerRef = useRef();
    let inputFileRef = useRef();

    const formStyle = {background_color: `rgba(${panColors.white}, 1)`,
                       border_color: `rgba(${panColors.middle_gray}, 1)`};
        
    const handleSelectFile = () => {
        inputFileRef.current.click();
    }

    const handleShowLanguage = (lang) => {
        //console.log("lang", lang);
        if(lang !== showLanguage){
            setShowLanguage(lang);
        }else{
            setShowLanguage(null);
        }
    }

    const subirArchivoAS3 = (imageProfileUploadURL, archivo) => {
        
        return new Promise((resolve, reject) => {

            abortControllerRef.current = new AbortController()

            const reader = new FileReader();

            reader.onload = () => {
                const archivoData = reader.result;
                var config = { headers: { 'Content-Type': archivo.type, },
                            signal: abortControllerRef.current.signal, onUploadProgress: function(progressEvent) {
                                                                            setPercent(Math.round( (progressEvent.loaded * 100) / progressEvent.total ));
                                                                        }
                            };
                axios.put(imageProfileUploadURL, archivoData, config).then(() => {
                    resolve(imageProfileUploadURL.split('?')[0]);
                }).catch((error) => {
                    reject(error.message);
                });
            };
            
            reader.onerror = (error) => {
                reject(error);
            };
            
            reader.readAsArrayBuffer(archivo);
        });

    };

    const handleRawFile = (e) => {
            /*
            if(scope !== "categories"){
                if(contentByLang[lang].medias.length >= limit){
                    setFileErrorMessage(t("texts.Se alcanzo el maximo de archivos permitido"));
                    hideMessage();
                    return null;
                }
            }
            */

            if(e.target.files.length){
                
                const file = e.target.files[0];
                //console.log("💚", file);
                //const size_limit_video = 75;
                //const size_limit_audio = 15;
                //const size_limit_archives = 30;
                //const size_limit_images = 10;
    
                let content_type = '';
                let message = '';
                let isValid = true;
                const file_type = file.type.split("/");
                const name = file.name;
                const extension = name.split('.').pop();
                const mime_type = file_type[0];
                const mime_extension = file_type[1];
                const size = ((file.size / 1024) / 1024);
                
                /*
                if(mime_type === "application" && applicationCount >= 1 && scope !== "product_downloads"){
                    setFileErrorMessage(t("texts.Se alcanzo el maximo de archivos permitido"));
                    hideMessage();
                    return null;
                }
    
                setLoadingMediaFile(true);
                
                switch (mime_type) {
                    
                    default:
                        isValid = false;
                        message = t("texts.El archivo que intenta agregar no esta permitido");
                        break;
                }
    
                if(isValid){
                    const datetime = DateTime.fromMillis(Date.now());
                    setFileErrorMessage("");
                    const filename = datetime+"."+extension;
                    const payload = { name: filename,
                                      path: "courses/" };
                    
                    setGettingUploadUrl(true);
                    const uploadRoute = getByPassImageUploadRoute(payload, "image/jpeg");
                    uploadRoute.then((res) => {
                        setGettingUploadUrl(false);
                        setPercent(0);
                        subirArchivoAS3(res, file)
                        .then((mensaje) => {
                            setPercent(null);
                            if(scope !== "categories"){
                                const slide = {id: `item${contentByLang[lang].medias.length+1}`, 
                                            name: `Item ${contentByLang[lang].medias.length+1}`, 
                                            media_type: content_type, 
                                            media_url: mensaje,
                                            media_name: name.length > 40 ? shortenFileName(name, 15) : name};
                                
                                let contentByLangUpdate = {...contentByLang};
                                contentByLangUpdate[lang].medias.push(slide);
                                setContentByLang(contentByLangUpdate);
                            }
                            if(scope === "categories"){
                                
                                const slide = {id: `item1`, 
                                            name: `Item1`, 
                                            media_type: content_type, 
                                            media_url: mensaje,
                                            media_name: name.length > 40 ? shortenFileName(name, 15) : name};
                                
                                let updateData = {...contentByLang};
                                updateData.translations[lang].image_big = slide;
                                updateData.translations[lang].medias = [slide];
                                setContentByLang(updateData);
                            }
                            
                            setLoadingMediaFile(false);
                            inputFileRef.current.value = '';
    
                            if(content_type === "Archives"){
                                setApplicationCount(1);
                            }
                        })
                        .catch((error) => {
                            inputFileRef.current.value = '';
                            setLoadingMediaFile(false);
                            setPercent(null);
                        });
                    })
                    
                }else{
                    setLoadingMediaFile(false);
                    setFileErrorMessage(message);
                    hideMessage();
                }
                */
    
                return null;
            }
        }
    
    const handleCancel = () => {
        abortControllerRef.current.abort();
    }

    const handleFormElementChange = (name, value) => {
        //console.log("👉", name, value)
        let updateData = {...contentByLang.translations[showLanguage].certificate};
        updateData[name].value = value;

        let contentByLangUpdate = {...contentByLang};
        contentByLangUpdate.translations[showLanguage].certificate = {...updateData};
        setContentByLang(contentByLangUpdate);

        //console.log("💜", contentByLangUpdate);
        /*
        let updateData = {...data};
            
            switch (name) {
                case 'description_short':
                    
                    updateData[name].value = value;
    
                    break;
    
                case 'description_long':
                    
                    updateData[name].value = value;
    
                    break;
    
                case 'title':
                    
                    let valid_title = validateNoTagsHTML(value);
                    if(valid_title){
                        updateData[name].error = true;
                    }else{
                        updateData[name].error = false;
                    }
                    updateData[name].value = value;
    
                    break;
                    
                default:
    
                    updateData[name].value = value;
    
                    break;
            }
    
            let contentByLangUpdate = {...contentByLang};
            contentByLangUpdate[lang] = updateData;
            setContentByLang(contentByLangUpdate);
            
            return null;
            */
        }






    useEffect(() => {
        //console.log("userCountrySelected", userCountrySelected);
        if(userCountrySelected){
            setShowLanguage(userCountrySelected.languages[0].language_identifier);

            const contentByLangUpdate = {...contentByLang};
            userCountrySelected.languages.map((lang) => {
                //
                if(!('certificate' in contentByLangUpdate.translations[lang.language_identifier])){
                    contentByLangUpdate.translations[lang.language_identifier].certificate = {};
                    //contentByLangUpdate.translations[lang.language_identifier].certificate = dataObjectEvaluationCertificate();
                }else{
                    if(!Object.keys(contentByLang.translations[lang.language_identifier].certificate).length){
                        contentByLangUpdate.translations[lang.language_identifier].certificate = dataObjectEvaluationCertificate(contentByLangUpdate.translations[lang.language_identifier].certificate);
                    }
                }
                //console.log("💚💚", contentByLangUpdate, dataObjectEvaluationCertificate(contentByLangUpdate.translations[lang.language_identifier].certificate))
                
            })

            setContentByLang(contentByLangUpdate);
            //console.log("💚", contentByLangUpdate);
        }
    return () => {}
    }, [userCountrySelected])

    useEffect(() => {
        //console.log("🐖", certificateLoaded);
        if(scope === 'edit'){
            if(!certificateLoaded){
                const contentByLangUpdate = {...contentByLang};
                Object.keys(contentByLangUpdate.translations).map((lang) => {
                    contentByLangUpdate.translations[lang].certificate = dataObjectEvaluationCertificate(contentByLangUpdate.translations[lang].certificate);
                })
                setContentByLang(contentByLangUpdate);
                setCertificateLoaded(true);
            }
            //console.log("❤️", scope, contentByLang);
            
        }

        return () => { }
    }, [])
    
    if(Object.keys(contentByLang).length === 0){
        return null;
    }

    return (
        // <Box sx={{ width: 750, p: 3 }}>
        <WrapperStyled pancolors={panColors}>

            <div className="title">
                {t("texts.Certificado")}
            </div>

            {userCountrySelected ?
                    userCountrySelected?.languages.map((lang, index) => {
                        return(
                            <div className={`box_lang ${userCountrySelected?.languages?.length > 1 ? " multilang" : ""}${(langHaveError.filter(langerror => langerror === lang.language_identifier).length ? ' error' : '')}${showLanguage === lang.language_identifier ? ' open' : ''}`}>
                                {userCountrySelected?.languages?.length > 1 &&
                                <div className="head_form_lang">
                                    <div className="title">
                                        <div className="icon">
                                            <LanguageIcon />
                                        </div>
                                        <div className="text">
                                            {t("texts.Pregunta en")} { getNameLanguage(userCountrySelected?.languages, lang.language_identifier) }
                                        </div>
                                    </div>
                                    {userCountrySelected?.languages.length ?
                                    <ButtonTextCustom 
                                        className="bt_show_more_info"
                                        text={`${showLanguage === lang.language_identifier ? t("texts.Cerrar") : t("texts.Abrir")}`}
                                        onClick={() => handleShowLanguage(lang.language_identifier)}

                                        icon={<BiSolidDownArrow />}
                                        background={{ normal: "", hover: "" }}
                                        border={{ normal: "", hover: "" }}
                                        textcolor={{ normal: panColors.primary, hover: panColors.primary }}
                                    /> : "" }
                                </div>
                                }

                                <div className={`question_type_container content_form${showLanguage === lang.language_identifier ? ' show' : ' hide'}`}>
                                    
                                    {('certificate' in contentByLang.translations[lang.language_identifier] && Object.keys(contentByLang.translations[lang.language_identifier].certificate).length) ?
                                        <div className='form_certificate'>
                                            <InputCustom 
                                                name={contentByLang.translations[lang.language_identifier].certificate.title.ref}
                                                label={t("texts."+contentByLang.translations[lang.language_identifier].certificate.title.label)}
                                                placeholder={t("texts."+contentByLang.translations[lang.language_identifier].certificate.title.placeholder)}
                                                onChange={handleFormElementChange}
                                                onKeyDown={null}
                                                className={`field field_${contentByLang.translations[lang.language_identifier].certificate.title.ref}${contentByLang.translations[lang.language_identifier].certificate.title.error ? " error" : ""}`}
                                                type="text"
                                                value={contentByLang.translations[lang.language_identifier].certificate.title.value}
                                                help={contentByLang.translations[lang.language_identifier].certificate.title.help}
                                                isRequired={contentByLang.translations[lang.language_identifier].certificate.title.required}
                                                styles={ formStyle }
                                                label_icon={null}
                                                tooltip_content={null}
                                                haveError={contentByLang.translations[lang.language_identifier].certificate.title.error}
                                            />
                                            <InputCustom 
                                                name={contentByLang.translations[lang.language_identifier].certificate.sub_title.ref}
                                                label={t("texts."+contentByLang.translations[lang.language_identifier].certificate.sub_title.label)}
                                                placeholder={t("texts."+contentByLang.translations[lang.language_identifier].certificate.sub_title.placeholder)}
                                                onChange={handleFormElementChange}
                                                onKeyDown={null}
                                                className={`field field_${contentByLang.translations[lang.language_identifier].certificate.sub_title.ref}${contentByLang.translations[lang.language_identifier].certificate.sub_title.error ? " error" : ""}`}
                                                type="text"
                                                value={contentByLang.translations[lang.language_identifier].certificate.sub_title.value}
                                                help={contentByLang.translations[lang.language_identifier].certificate.sub_title.help}
                                                isRequired={contentByLang.translations[lang.language_identifier].certificate.sub_title.required}
                                                styles={ formStyle }
                                                label_icon={null}
                                                tooltip_content={null}
                                                haveError={contentByLang.translations[lang.language_identifier].certificate.sub_title.error}
                                            />
                                            <TextareaCustom 
                                                name={contentByLang.translations[lang.language_identifier].certificate.description.ref}
                                                label={t("texts."+contentByLang.translations[lang.language_identifier].certificate.description.label)}
                                                placeholder={t("texts."+contentByLang.translations[lang.language_identifier].certificate.description.placeholder)}
                                                onChange={handleFormElementChange}
                                                onKeyDown={null}
                                                className={`field field_${contentByLang.translations[lang.language_identifier].certificate.description.ref}${contentByLang.translations[lang.language_identifier].certificate.description.error ? " error" : ""}`}
                                                type="text"
                                                value={contentByLang.translations[lang.language_identifier].certificate.description.value}
                                                help={""}
                                                isRequired={contentByLang.translations[lang.language_identifier].certificate.description.required}
                                                styles={ formStyle }
                                                label_icon={<HeadlineIcon />}
                                                tooltip_content={contentByLang.translations[lang.language_identifier].certificate.description.tooltip && t("texts."+contentByLang.translations[lang.language_identifier].certificate.description.tooltip)}
                                                haveError={contentByLang.translations[lang.language_identifier].certificate.description.error}
                                            />
                                            <TextareaCustom 
                                                name={contentByLang.translations[lang.language_identifier].certificate.sub_description.ref}
                                                label={t("texts."+contentByLang.translations[lang.language_identifier].certificate.sub_description.label)}
                                                placeholder={t("texts."+contentByLang.translations[lang.language_identifier].certificate.sub_description.placeholder)}
                                                onChange={handleFormElementChange}
                                                onKeyDown={null}
                                                className={`field field_${contentByLang.translations[lang.language_identifier].certificate.sub_description.ref}${contentByLang.translations[lang.language_identifier].certificate.sub_description.error ? " error" : ""}`}
                                                type="text"
                                                value={contentByLang.translations[lang.language_identifier].certificate.sub_description.value}
                                                help={""}
                                                isRequired={contentByLang.translations[lang.language_identifier].certificate.sub_description.required}
                                                styles={ formStyle }
                                                label_icon={<HeadlineIcon />}
                                                tooltip_content={contentByLang.translations[lang.language_identifier].certificate.sub_description.tooltip && t("texts."+contentByLang.translations[lang.language_identifier].certificate.sub_description.tooltip)}
                                                haveError={contentByLang.translations[lang.language_identifier].certificate.sub_description.error}
                                            />

                                            {/* <InputSelectCustom 
                                                name={contentByLang.translations[lang.language_identifier].certificate.signature.ref}
                                                label={t("texts."+contentByLang.translations[lang.language_identifier].certificate.signature.label)}
                                                placeholder={t("texts."+contentByLang.translations[lang.language_identifier].certificate.signature.placeholder)}
                                                onChange={handleFormElementChange}
                                                onKeyDown={null}
                                                className={`field field_${contentByLang.translations[lang.language_identifier].certificate.signature.ref}${contentByLang.translations[lang.language_identifier].certificate.signature.error ? " error" : ""}`}
                                                type="text"
                                                value={contentByLang.translations[lang.language_identifier].certificate.signature.value}
                                                help={contentByLang.translations[lang.language_identifier].certificate.signature.help}
                                                isRequired={contentByLang.translations[lang.language_identifier].certificate.signature.required}
                                                styles={ formStyle }
                                                label_icon={null}
                                                tooltip_content={null}
                                                haveError={contentByLang.translations[lang.language_identifier].certificate.signature.error}
                                            />

                                            <InputSelectCustom 
                                                name={contentByLang.translations[lang.language_identifier].certificate.main_icon.ref}
                                                label={t("texts."+contentByLang.translations[lang.language_identifier].certificate.main_icon.label)}
                                                placeholder={t("texts."+contentByLang.translations[lang.language_identifier].certificate.main_icon.placeholder)}
                                                onChange={handleFormElementChange}
                                                onKeyDown={null}
                                                className={`field field_${contentByLang.translations[lang.language_identifier].certificate.main_icon.ref}${contentByLang.translations[lang.language_identifier].certificate.main_icon.error ? " error" : ""}`}
                                                type="text"
                                                value={contentByLang.translations[lang.language_identifier].certificate.main_icon.value}
                                                help={contentByLang.translations[lang.language_identifier].certificate.main_icon.help}
                                                isRequired={contentByLang.translations[lang.language_identifier].certificate.main_icon.required}
                                                styles={ formStyle }
                                                label_icon={null}
                                                tooltip_content={null}
                                                haveError={contentByLang.translations[lang.language_identifier].certificate.main_icon.error}
                                            /> */}

                                            <UploaderFileContainer 
                                                scope={scope}
                                                className={'uploader_file'}
                                                contentByLang={contentByLang}
                                                setContentByLang={setContentByLang}
                                                lang={lang.language_identifier}
                                                item={'signature'}
                                            />

                                            <UploaderFileContainer 
                                                scope={scope}
                                                className={'uploader_file'}
                                                contentByLang={contentByLang}
                                                setContentByLang={setContentByLang}
                                                lang={lang.language_identifier}
                                                item={'main_icon'}
                                            />

                                            <UploaderFileContainer 
                                                scope={scope}
                                                className={'uploader_file'}
                                                contentByLang={contentByLang}
                                                setContentByLang={setContentByLang}
                                                lang={lang.language_identifier}
                                                item={'secondary_icon'}
                                            />

                                            <UploaderFileContainer 
                                                scope={scope}
                                                className={'uploader_file'}
                                                contentByLang={contentByLang}
                                                setContentByLang={setContentByLang}
                                                lang={lang.language_identifier}
                                                item={'main_background'}
                                            />

                                            <UploaderFileContainer 
                                                scope={scope}
                                                className={'uploader_file'}
                                                contentByLang={contentByLang}
                                                setContentByLang={setContentByLang}
                                                lang={lang.language_identifier}
                                                item={'secondary_background'}
                                            />
                                            
                                            {/* <input className='input_file' type="file" ref={inputFileRef} onChange={handleRawFile}/> */}

                                            {/* <UploadMediaMultiLang 
                                                className={`upload_media ${hideMediaSlide ? "hide" : "show"}`}
                                                lang={lang}
                                                contentByLang={contentByLang}
                                                setContentByLang={setContentByLang}
                                                mediaSlices={mediaSlices}
                                                setMediaSlices={setMediaSlices}
                                                required={true}
                                                haveError={mediaError[lang]}
                                                actionButtonText={t("texts.+ Agregar (Video/Audio/Imagen)")}
                                                scope={"posts"}
                                                limit={15}
                                            />  */}

                                        </div>
                                    : "" }


                                </div>

                            </div>
                        )
                    })
                : "" }



            
            {/* Aquí puedes agregar el formulario o contenido para cargar el certificado */}
            {/* <Button
                variant="contained"
                color="primary"
                onClick={handleCloseCertificateDrawer}
                sx={{ mt: 2 }}
                fullWidth
            >
                {t("texts.Cerrar")}
            </Button> */}
        </WrapperStyled>
        // </Box>
    );
};

export default Certificate;